export function setToken(token: string) {
	localStorage.setItem("celebrant-briefcase-token", token)
}

export function getToken() {
	return localStorage.getItem("celebrant-briefcase-token")
}
